import { render, staticRenderFns } from "./DesktopOnlyNotice.vue?vue&type=template&id=0dc998c6&scoped=true"
import script from "./DesktopOnlyNotice.vue?vue&type=script&lang=js"
export * from "./DesktopOnlyNotice.vue?vue&type=script&lang=js"
import style0 from "./DesktopOnlyNotice.vue?vue&type=style&index=0&id=0dc998c6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc998c6",
  null
  
)

export default component.exports